import { useEffect, useState } from "react";

export function useLocalStorage(key: any, initialData: any) {
  if (!key) {
    return;
  }
  const [data, setData] = useState(initialData);

  useEffect(() => {
    if (key) {
      const data = localStorage.getItem(key);
      const existingData: any = data ? JSON.parse(data) : null;

      if (existingData) {
        setData(existingData);
      } else {
        localStorage.setItem(key, JSON.stringify(initialData));
      }
    }
  }, []);

  const updateLocalStorage = (newData: any) => {
    if (typeof newData === "function") {
      localStorage.setItem(key, JSON.stringify(newData(data)));
    } else {
      localStorage.setItem(key, JSON.stringify(newData));
    }

    setData(newData);
  };

  const removeLocalStorageKey = () => {
    localStorage.removeItem(key);
  };

  return [data, updateLocalStorage, removeLocalStorageKey];
}
